<template>
  <v-card
    class="caseCard"
    :tile="tile"
    :elevation="elevation"
    color="cardSurface"
    :outlined="$vuetify.theme.dark"
    @click.stop="clickCard"
  >
    <v-sheet v-if="!removeSideline" class="cardStatusSideline" :color="color">
    </v-sheet>
    <v-list color="cardSurface pb-0">
      <v-list-item>
        <v-list-item-content class="py-2">
          <v-list-item-title v-if="!loading" class="title">
            <slot name="title" :title="title">
              {{ title }}
            </slot>
          </v-list-item-title>
          <v-skeleton-loader v-if="loading" type="heading"></v-skeleton-loader>
        </v-list-item-content>

        <v-list-item-icon v-if="!removeArrowIcon" class="my-2">
          <slot name="topRight">
            <v-icon>mdi-arrow-right</v-icon>
          </slot>
        </v-list-item-icon>
      </v-list-item>

      <v-list-item class="align-center justify-space-between pb-2">
        <div class="d-flex flex-grow-1">
          <slot name="chips" :chips="chips">
            <div v-for="(chip, index) in chips" :key="index">
              <v-chip class="mr-2" :color="chip.color" small>
                {{ chip.title }}
              </v-chip>
            </div>
          </slot>

          <v-skeleton-loader
            v-if="loading"
            class="chipSmall mr-2"
            type="chip"
          ></v-skeleton-loader>
          <v-skeleton-loader
            v-if="loading"
            class="chipSmall chipShortwidth"
            type="chip"
          ></v-skeleton-loader>
        </div>
        <slot name="deadline" :deadline="deadline">
          <p
            class="mb-0"
            :class="{ textError: dateIsOut(deadline) }"
            v-if="deadline"
          >
            <v-icon v-if="dateIsOut(deadline)" small color="error">
              mdi-calendar-alert
            </v-icon>
            Frist: {{ deadline | moment("DD.MM.YYYY") }}
          </p>
        </slot>
      </v-list-item>
      <v-divider v-if="!removeBottom"></v-divider>
      <v-list-item v-if="!removeBottom" class="underListItem align-center py-2">
        <small v-if="!loading">
          <slot name="underLeft" :underLeft="underLeft">
            {{ underLeft }}
          </slot>
        </small>

        <small v-if="!loading" class="ml-auto">
          <slot name="underRight" :underRight="underRight">
            {{ underRight }}
          </slot>
        </small>

        <v-skeleton-loader
          v-if="loading"
          class="chipSmall"
          type="chip"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="loading"
          class="chipSmall ml-auto"
          type="chip"
        ></v-skeleton-loader>
      </v-list-item>
      <!-- <v-divider class="mb-0 pb-0"></v-divider> -->
    </v-list>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";

interface chipsObject {
  title: string;
  color: string;
}

export default Vue.extend({
  props: {
    loading: {
      type: Boolean,
    },
    tile: {
      type: Boolean,
    },
    elevation: {
      type: Number,
    },
    title: {
      type: String,
    },
    chips: {
      type: Array as () => Array<chipsObject>,
    },
    color: {
      type: String,
      default: "primary",
    },
    deadline: {
      type: String,
    },
    underLeft: {
      type: String,
    },
    underRight: {
      type: String,
    },
    removeSideline: {
      type: Boolean,
      default: false,
    },
    removeArrowIcon: {
      type: Boolean,
      default: false,
    },
    removeBottom: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickCard() {
      this.$emit("click");
    },
    dateIsOut(deadline) {
      return moment().isAfter(deadline);
    },
  },
});
</script>

<style lang="scss">
.caseCardContainer:nth-child(even) .v-list {
  background-color: var(--v-listHighlight-base) !important;
}

.caseCard {
  .v-list {
    .v-list-item {
      min-height: unset;
    }
  }
}
.chipSmall {
  .v-skeleton-loader__chip {
    height: 25px;
  }
}
.chipShortwidth {
  .v-skeleton-loader__chip {
    width: 60px;
  }
}

.underListItem {
  height: 35px;
}
</style>

<style lang="scss">
.textError {
  color: var(--v-error-base);
}
</style>
